Attributes of the updated position profile.
